// frontend/src/data/scienceData.js
// Справочник научных направлений, компетенций и областей для Финансового университета

// ============================================
// 1. УРОВНИ ОБРАЗОВАНИЯ
// ============================================
export const EDUCATION_LEVELS = [
  { value: 'spo', label: 'Среднее профессиональное образование (СПО)' },
  { value: 'bachelor', label: 'Бакалавриат' },
  { value: 'master', label: 'Магистратура' },
  { value: 'postgraduate', label: 'Аспирантура' }
];

// ============================================
// 2. ФИЛИАЛЫ ФИНАНСОВОГО УНИВЕРСИТЕТА
// ============================================
export const UNIVERSITY_BRANCHES = [
  "Алтайский филиал Финуниверситета",
  "Владикавказский филиал Финуниверситета",
  "Владимирский филиал Финуниверситета",
  "Калужский филиал Финуниверситета",
  "Краснодарский филиал Финуниверситета",
  "Курский филиал Финуниверситета",
  "Липецкий филиал Финуниверситета",
  "Новороссийский филиал Финуниверситета",
  "Омский филиал Финуниверситета",
  "Орловский филиал Финуниверситета",
  "Пензенский филиал Финуниверситета",
  "Санкт-Петербургский филиал Финуниверситета",
  "Смоленский филиал Финуниверситета",
  "Тульский филиал Финуниверситета",
  "Уральский филиал Финуниверситета",
  "Уфимский филиал Финуниверситета",
  "Ярославский филиал Финуниверситета",
  "Благовещенский финансово-экономический колледж",
  "Бузулукский финансово-экономический колледж",
  "Звенигородский финансово-экономический колледж",
  "Канашский финансово-экономический колледж",
  "Красноярский финансово-экономический колледж",
  "Махачкалинский финансово-экономический колледж",
  "Московский финансовый колледж",
  "Пермский финансово-экономический колледж",
  "Самарский финансово-экономический колледж",
  "Сургутский финансово-экономический колледж",
  "Шадринский финансово-экономический колледж",
  "Колледж информатики и программирования"
].sort();

// ============================================
// 3. ДОЛЖНОСТИ
// ============================================
export const POSITIONS = [
  // Для студентов
  { value: 'student', name: 'Студент', category: 'student' },
  { value: 'spo_student', name: 'Студент колледжа (СПО)', category: 'student' },
  { value: 'bachelor', name: 'Студент бакалавриата', category: 'student' },
  { value: 'master', name: 'Студент магистратуры', category: 'student' },
  { value: 'postgraduate', name: 'Аспирант', category: 'student' },
  { value: 'doctoral', name: 'Докторант', category: 'student' },
  { value: 'listener', name: 'Слушатель', category: 'student' },
  { value: 'intern', name: 'Стажер', category: 'student' },

  // Для сотрудников
  { value: 'lecturer', name: 'Преподаватель', category: 'staff' },
  { value: 'senior_lecturer', name: 'Старший преподаватель', category: 'staff' },
  { value: 'docent', name: 'Доцент', category: 'staff' },
  { value: 'professor', name: 'Профессор', category: 'staff' },
  { value: 'head_of_department', name: 'Заведующий кафедрой', category: 'staff' },
  { value: 'dean', name: 'Декан факультета', category: 'staff' },
  { value: 'researcher', name: 'Научный сотрудник', category: 'staff' },
  { value: 'senior_researcher', name: 'Ведущий научный сотрудник', category: 'staff' },
  { value: 'lab_assistant', name: 'Лаборант', category: 'staff' },
  { value: 'assistant', name: 'Ассистент', category: 'staff' },
  { value: 'methodist', name: 'Методист', category: 'staff' }
];

// ============================================
// 4. УЧЕНЫЕ СТЕПЕНИ
// ============================================
export const ACADEMIC_DEGREES = [
  'Нет ученой степени',
  'доктор биологических наук',
  'доктор ветеринарных наук',
  'доктор военных наук',
  'доктор географических наук',
  'доктор геолого-минералогических наук',
  'доктор искусствоведения',
  'доктор исторических наук',
  'доктор культурологи',
  'доктор медицинских наук',
  'доктор педагогических наук',
  'доктор политических наук',
  'доктор психологических наук',
  'доктор сельскохозяйственных наук',
  'доктор социологических наук',
  'доктор технических наук',
  'доктор фармацевтических наук',
  'доктор физико-математических наук',
  'доктор филологических наук',
  'доктор философских наук',
  'доктор химических наук',
  'доктор экономических наук',
  'доктор юридических наук',
  'кандидат биологических наук',
  'кандидат ветеринарных наук',
  'кандидат военных наук',
  'кандидат географических наук',
  'кандидат геолого-минералогических наук',
  'кандидат искусствоведения',
  'кандидат исторических наук',
  'кандидат культурологи',
  'кандидат медицинских наук',
  'кандидат педагогических наук',
  'кандидат политических наук',
  'кандидат психологических наук',
  'кандидат сельскохозяйственных наук',
  'кандидат социологических наук',
  'кандидат технических наук',
  'кандидат фармацевтических наук',
  'кандидат физико-математических наук',
  'кандидат филологических наук',
  'кандидат философских наук',
  'кандидат химических наук',
  'кандидат экономических наук',
  'кандидат юридических наук',
  'PhD'
].sort();

// ============================================
// 5. НАУЧНЫЕ НАПРАВЛЕНИЯ (ИЕРАРХИЧЕСКИЕ)
// ============================================
export const RESEARCH_FIELDS = {
  mathematics: {
    name: 'Математика, информатика и науки о системах',
    items: [
      'Алгоритмическое и программное обеспечение',
      'Информатика',
      'Инфокоммуникационные технологии и вычислительные системы',
      'Математика',
      'Механика',
      'Сетевые технологии',
      'Теория управления'
    ].sort()
  },
  physics: {
    name: 'Физика и науки о космосе',
    items: [
      'Астрономия',
      'Оптика, квантовая электроника',
      'Радиофизика, электроника, акустика',
      'Теоретическая физика',
      'Физика конденсированных сред',
      'Физика плазмы',
      'Ядерная физика'
    ].sort()
  },
  chemistry: {
    name: 'Химия и науки о материалах',
    items: [
      'Высокомолекулярные соединения',
      'Динамика и структура атомно-молекулярных систем',
      'Многомасштабное компьютерное моделирование структуры и свойств сложных химических систем и материалов',
      'Неорганическая химия',
      'Органическая химия',
      'Физическая химия',
      'Фундаментальные проблемы формирования новых материалов'
    ].sort()
  },
  biology: {
    name: 'Биология и науки о жизни',
    items: [
      'Общая биология',
      'Физико-химическая биология',
      'Экология'
    ].sort()
  },
  medicine: {
    name: 'Медицина',
    items: [
      'Клиническая медицина',
      'Медицинская физика',
      'Медицинские биотехнологии',
      'Медицинские техника и информатика',
      'Науки о здоровье',
      'Фармакология и фармацевтика',
      'Фундаментальная медицина'
    ].sort()
  },
  agriculture: {
    name: 'Сельскохозяйственные науки',
    items: [
      'Земледелие и растениеводство',
      'Зоотехния',
      'Теоретические основы и технология пищевых продуктов'
    ].sort()
  },
  earth: {
    name: 'Науки о Земле',
    items: [
      'География и гидрология суши',
      'Геология',
      'Геофизика',
      'Геохимия',
      'Горные науки',
      'Океанология',
      'Социальная и экономическая география',
      'Физика атмосферы'
    ].sort()
  },
  history: {
    name: 'Исторические науки',
    items: [
      'Археология',
      'История древнего мира',
      'История России',
      'История Средних веков и эпохи Возрождения',
      'История стран Азии и Африки',
      'Новая и новейшая история стран Европы и Америки',
      'Религиоведение',
      'Этнология и антропология'
    ].sort()
  },
  economics: {
    name: 'Экономические науки',
    items: [
      'История экономических учений',
      'Мировая экономика и международные экономические отношения',
      'Отраслевая экономика',
      'Прогнозирование социально-экономического развития',
      'Региональная и городская экономика',
      'Социальные аспекты экономики и рынок труда',
      'Финансы, кредит, денежное обращение, инфраструктура рынка',
      'Экономика предпринимательства'
    ].sort()
  },
  philosophy: {
    name: 'Философские науки',
    items: [
      'Логика. Философия языка',
      'Социальная философия. Философия истории',
      'Теория познания и философская онтология',
      'Философия и методология науки',
      'Этика. Эстетика. Философия религии. Теология'
    ].sort()
  },
  political: {
    name: 'Политология',
    items: [
      'История политической мысли',
      'Международная безопасность',
      'Мировая политика',
      'Политические институты и процессы',
      'Предметные области политологических исследований'
    ].sort()
  },
  sociology: {
    name: 'Социология',
    items: [
      'Гендерные исследования',
      'Демография',
      'Исследования социальных проблем',
      'Отраслевые социологии',
      'Теория, методология и история социологии, методы социологических исследований'
    ].sort()
  },
  law: {
    name: 'Юридические науки',
    items: [
      'Административное право. Финансовое право. Административная юстиция',
      'Гражданское право. Предпринимательское право. Семейное право. Информационное право',
      'Земельное право. Природоохранное право',
      'Конституционное право. Публичное право. Муниципальное право и местное самоуправление',
      'Международное право. Универсальное и региональное международное право. Международное частное и публичное право',
      'Социальное право. Трудовое право. Пенсионное право',
      'Судопроизводство по уголовным делам и гражданским делам',
      'Теории права и государства, методы их изучения',
      'Уголовное право. Криминология'
    ].sort()
  },
  philology: {
    name: 'Филологические науки',
    items: [
      'Литературоведение',
      'Текстология',
      'Филология',
      'Языкознание'
    ].sort()
  },
  art: {
    name: 'Искусствоведение',
    items: [
      'Музыковедение',
      'Театроведение',
      'Теория и история архитектуры',
      'Теория и история изобразительного искусства',
      'Фольклористика'
    ].sort()
  },
  psychology: {
    name: 'Психология',
    items: [
      'Общая психология, методология и история психологии, психология личности',
      'Психология развития, педагогическая психология, коррекционная психология, психология образования',
      'Психология труда, инженерная психология, организационная психология',
      'Психофизиология, психогенетика, сравнительная психология, зоопсихология, эволюционная психология',
      'Социальная психология, этническая и кросс-культурная психология, политическая психология, юридическая психология, экономическая психология'
    ].sort()
  },
  pedagogy: {
    name: 'Педагогика',
    items: [
      'Общая педагогика, история педагогики и образования',
      'Специальная педагогика и образование, инклюзивное образование',
      'Теория и методология воспитания',
      'Теория и методология инновационных процессов в образовании, экспериментальная и инновационная деятельность в образовании',
      'Теория и методология обучения',
      'Теория и методология профессионального образования',
      'Теория и методология физической культуры'
    ].sort()
  },
  culture: {
    name: 'Культурология',
    items: [
      'Культура в современном мире',
      'Культура и личность',
      'Национальная идентичность и взаимодействие культур',
      'Охрана памятников истории и культуры',
      'Теория, методология и история изучения культуры'
    ].sort()
  }
};

// ============================================
// 6. КОМПЕТЕНЦИИ
// ============================================
export const COMPETENCIES = {
  analytical: {
    name: 'Аналитические навыки',
    items: [
      'SWOT-анализ',
      'Анализ больших данных',
      'Анализ безубыточности',
      'Анализ временных рядов',
      'Анализ денежных потоков',
      'Анализ рынка',
      'Анализ финансовой отчетности',
      'Анализ цепочек создания стоимости',
      'Data Mining',
      'Инвестиционный анализ',
      'Кластерный анализ',
      'Конкурентный анализ',
      'Коэффициентный анализ',
      'Маркетинговый анализ',
      'Налоговый анализ',
      'Панельные данные',
      'PEST-анализ',
      'Прогнозирование',
      'Регрессионный анализ',
      'Риск-анализ',
      'Сетевой анализ',
      'Статистический анализ',
      'Сценарный анализ',
      'Текстовая аналитика',
      'Факторный анализ',
      'Финансовый анализ',
      'Эконометрическое моделирование'
    ].sort()
  },
  research: {
    name: 'Исследовательские навыки',
    items: [
      'Анкетирование',
      'Архивные исследования',
      'Библиометрический анализ',
      'Дизайн исследования',
      'Дискурс-анализ',
      'Интервьюирование',
      'Кейс-стади',
      'Контент-анализ',
      'Кросс-культурные исследования',
      'Мета-анализ',
      'Наблюдение',
      'Наукометрия',
      'Нарративный анализ',
      'Обзор литературы',
      'Планирование исследований',
      'Полевые исследования',
      'Работа с историческими документами',
      'Систематический обзор',
      'Сбор данных',
      'Сравнительный анализ',
      'Фокус-группы',
      'Формулировка гипотез',
      'Экспериментальный дизайн',
      'Экспертные опросы',
      'Этнография'
    ].sort()
  },
  quantitative: {
    name: 'Количественные методы',
    items: [
      'Анализ временных рядов',
      'Анализ выживаемости',
      'Байесовские методы',
      'Глубокое обучение',
      'Динамическое программирование',
      'Имитационное моделирование',
      'Классификация',
      'Кластеризация',
      'Компьютерное зрение',
      'Математическое моделирование',
      'Машинное обучение',
      'Монте-Карло симуляции',
      'Нейронные сети',
      'Оптимизационные модели',
      'Обработка естественного языка',
      'Прогнозирование временных рядов',
      'Распознавание образов',
      'Стохастические процессы',
      'Теория игр'
    ].sort()
  },
  economic: {
    name: 'Экономические компетенции',
    items: [
      'Институциональная экономика',
      'Международная экономика',
      'Микроэкономический анализ',
      'Макроэкономический анализ',
      'Поведенческая экономика',
      'Пространственная экономика',
      'Региональная экономика',
      'Цифровая экономика',
      'Эволюционная экономика',
      'Экологическая экономика',
      'Экономика знаний',
      'Экономика здравоохранения',
      'Экономика инноваций',
      'Экономика образования',
      'Экономика отраслевых рынков',
      'Экономика общественного сектора',
      'Экономика развития',
      'Экономика фирмы',
      'Экспериментальная экономика'
    ].sort()
  },
  financial: {
    name: 'Финансовые компетенции',
    items: [
      'Актуарные расчеты',
      'Андеррайтинг',
      'Банковское дело',
      'Бюджетирование',
      'Деривативы',
      'Инвестиционный анализ',
      'Корпоративные финансы',
      'Краудфандинг',
      'Кредитный анализ',
      'Криптовалюты и блокчейн',
      'Оценка бизнеса',
      'Оценка инвестиционных проектов',
      'Портфельные инвестиции',
      'Риск-менеджмент',
      'Страхование',
      'Структурированные продукты',
      'Технический анализ',
      'Трейдинг',
      'Управление активами',
      'Управление инвестициями',
      'Управление оборотным капиталом',
      'Управление рисками',
      'Финансовые рынки',
      'Финансовые технологии (FinTech)',
      'Финансовый инжиниринг',
      'Финансовый контроль',
      'Финансовый менеджмент',
      'Финансовое планирование',
      'Фундаментальный анализ',
      'Хеджирование'
    ].sort()
  },
  technical: {
    name: 'Технические навыки',
    items: [
      '1С:Предприятие',
      'Bloomberg',
      'Deductor',
      'Django',
      'EViews',
      'Excel (продвинутый уровень)',
      'Flask',
      'Git',
      'Gretl',
      'Julia',
      'Keras',
      'KNIME',
      'MATLAB',
      'Matplotlib',
      'NumPy',
      'Orange',
      'Oracle',
      'Pandas',
      'Plotly',
      'PolyAnalyst',
      'Power BI',
      'PyTorch',
      'Python',
      'QlikView',
      'R',
      'RapidMiner',
      'React',
      'Reuters Eikon',
      'SAP',
      'SAS',
      'scikit-learn',
      'SciPy',
      'Seaborn',
      'SPSS',
      'SQL',
      'Stata',
      'Statistica',
      'STATISTICA',
      'Tableau',
      'TensorFlow',
      'VBA',
      'Weka'
    ].sort()
  },
  languages: {
    name: 'Языки',
    items: [
      'Английский (научное письмо)',
      'Английский (свободное владение)',
      'Английский (устная коммуникация)',
      'Английский (чтение литературы)',
      'Арабский',
      'Другие восточные',
      'Другие европейские',
      'Испанский',
      'Итальянский',
      'Китайский',
      'Корейский',
      'Немецкий',
      'Польский',
      'Турецкий',
      'Французский',
      'Чешский',
      'Японский'
    ].sort()
  },
  soft: {
    name: 'Мягкие навыки',
    items: [
      'Академическое письмо',
      'Грантрайтинг',
      'Корректура',
      'Менторство',
      'Междисциплинарное взаимодействие',
      'Модерация сессий',
      'Наставничество',
      'Научная дискуссия',
      'Научная коммуникация',
      'Научное письмо',
      'Научное редактирование',
      'Написание заявок на гранты',
      'Организация конференций',
      'Отчетность по проектам',
      'Презентационные навыки',
      'Публичные выступления',
      'Работа в команде',
      'Рецензирование',
      'Тайм-менеджмент',
      'Управление проектами',
      'Экспертная деятельность'
    ].sort()
  }
};

// ============================================
// 7. МЕТОДОЛОГИИ И ПОДХОДЫ
// ============================================
export const METHODOLOGIES = [
  'Анализ временных рядов',
  'Анализ выживаемости',
  'Анализ латентных классов',
  'Байесовские методы',
  'Библиометрический анализ',
  'Дискурс-анализ',
  'Дисперсионный анализ',
  'Иерархические модели',
  'Имитационное моделирование',
  'Качественные исследования',
  'Кейс-стади',
  'Кластерный анализ',
  'Ковариационный анализ',
  'Контент-анализ',
  'Корреляционный анализ',
  'Математическое моделирование',
  'Мета-анализ',
  'Наукометрия',
  'Оптимизационные модели',
  'Панельные данные',
  'Прогнозирование',
  'Регрессионный анализ',
  'Риск-анализ',
  'Сетевой анализ',
  'Системный анализ',
  'Сравнительный анализ',
  'Статистический анализ',
  'Сценарное планирование',
  'Факторный анализ',
  'Эконометрическое моделирование',
  'Экспертные оценки'
].sort();

// ============================================
// 8. ТИПЫ ПУБЛИКАЦИЙ
// ============================================
export const PUBLICATION_TYPES = [
  'Аналитические отчеты',
  'Главы в монографиях',
  'Коллективные монографии',
  'Материалы конференций',
  'Монографии',
  'Научные доклады',
  'Препринты',
  'Рецензии',
  'РИНЦ',
  'Словари и справочники',
  'Статьи ВАК',
  'Статьи Scopus',
  'Статьи Web of Science',
  'Тезисы конференций',
  'Учебники',
  'Учебные пособия'
].sort();

// ============================================
// 9. ТИПЫ СОТРУДНИЧЕСТВА
// ============================================
export const COLLABORATION_TYPES = [
  'Грантовые заявки',
  'Консультирование',
  'Междисциплинарные проекты',
  'Научное редактирование',
  'Научное руководство',
  'Обмен данными',
  'Обмен опытом',
  'Организация конференций',
  'Приглашенное редактирование',
  'Рецензирование',
  'Совместные исследования',
  'Совместные монографии',
  'Совместные статьи',
  'Совместные эксперименты',
  'Стажировки',
  'Экспертиза'
].sort();

// ============================================
// 10. ПОПУЛЯРНЫЕ НАПРАВЛЕНИЯ (ДЛЯ БЫСТРОГО ВЫБОРА)
// ============================================
export const POPULAR_RESEARCH_AREAS = (() => {
  const areas = [];
  Object.values(RESEARCH_FIELDS).forEach(category => {
    areas.push(...category.items);
  });
  return areas.sort();
})();

// ============================================
// 11. ФУНКЦИИ ПОМОЩНИКИ (ОБНОВЛЕНЫ)
// ============================================

/**
 * Возвращает плоский список всех научных направлений
 */
export const getAllResearchFields = () => {
  const allFields = [];
  Object.values(RESEARCH_FIELDS).forEach(category => {
    allFields.push(...category.items);
  });
  return allFields.sort();
};

/**
 * Поиск по всем справочникам
 */
export const searchScienceData = (query) => {
  if (!query || query.length < 2) return [];

  const results = [];
  const lowerQuery = query.toLowerCase();

  // Поиск по компетенциям
  Object.values(COMPETENCIES).forEach(category => {
    category.items.forEach(item => {
      if (item.toLowerCase().includes(lowerQuery)) {
        results.push({
          type: 'Компетенция',
          category: category.name,
          value: item
        });
      }
    });
  });

  // Поиск по методологиям
  METHODOLOGIES.forEach(method => {
    if (method.toLowerCase().includes(lowerQuery)) {
      results.push({
        type: 'Методология',
        category: 'Методологии',
        value: method
      });
    }
  });

  // Поиск по филиалам
  UNIVERSITY_BRANCHES.forEach(branch => {
    if (branch.toLowerCase().includes(lowerQuery)) {
      results.push({
        type: 'Филиал',
        category: 'Филиалы',
        value: branch
      });
    }
  });

  // Поиск по должностям
  POSITIONS.forEach(pos => {
    if (pos.name.toLowerCase().includes(lowerQuery)) {
      results.push({
        type: 'Должность',
        category: pos.category === 'student' ? 'Обучающиеся' : 'Сотрудники',
        value: pos.name
      });
    }
  });

  // Поиск по научным направлениям
  Object.values(RESEARCH_FIELDS).forEach(category => {
    category.items.forEach(item => {
      if (item.toLowerCase().includes(lowerQuery)) {
        results.push({
          type: 'Научное направление',
          category: category.name,
          value: item
        });
      }
    });
  });

  return results.slice(0, 30);
};